
import {Component, Vue} from 'vue-property-decorator';
import SetTableColumns from "@/components/SetTableColumns.vue";
import {IPage} from "@/js/page";
import {mechanismApi} from "@/api/organization";
import Layout from "@/views/integrity/Layout.vue";
import {imageUrl} from "@/constants";
const {CodeToText} =require("@/js/region/region");

@Component({
  name: 'AuditMechanismChangeApply',
  methods: {
    imageUrl() {
      return imageUrl
    },
  },
  components: {Layout, SetTableColumns}
})
export default class MaterialList extends Vue {
  modeType = "Pending";
  private closePage: any;
  screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
  showForm = false;//查询条件隐藏展示
  load = false;//加载
  dataList = []; //数据列表
  CodeToText = CodeToText;
  reasonDialog = {
    visible: false,
    id: '',
    reason: ''
  }
  changeApplyDialog = {
    visible: false,
    mode: "AUDIT", // AUDIT OR VIEW
    info: null
  }
  tabCol = [];
  allSelected = [];//列表选中数据
  propParams = this.getPropParams();
  total = 0;
  listParam: IPage = {
    size: 50,
    current: 1,
  };

  getPropParams() {
    return {
      name: '',
      code: '',
      auditStatus: ''
    }
  }

  created() {
    this.init();
  }

  reset() {
    this.propParams = this.getPropParams();
    this.refresh();
  }

  refresh() {
    this.allSelected = [];
    let $table = this.$refs.table as HTMLFormElement;
    $table.clearSelection();
    this.listParam.current = 1;
    this.loadData(null);
  }

  tableClearSelect() {
    this.allSelected = [];
    let $table = this.$refs.table as HTMLFormElement;
    if ($table) {
      $table.clearSelection();
    }
  }

  init() {
    this.loadData(null);
  }



  onNotPassed(id: any){
      this.reasonDialog.id = id;
      this.reasonDialog.reason = "";
      this.reasonDialog.visible = true;
  }

  onAudit(id: any, status: number){
    const reason =  this.reasonDialog.reason;
    mechanismApi.auditChangeApply({id: id, auditStatus: status, reason: reason}).then((r: any) => {
      if(r.data.result === 0){
        this.$message.success("审核成功");
        this.closeDialog();
        this.refresh();
      }
    });
  }

  closeDialog(){
    this.changeApplyDialog.visible = false;
    this.changeApplyDialog.info = null;
    this.reasonDialog.reason = "";
    this.reasonDialog.visible = false;
  }

  loadData(callback: any) {
    this.tableClearSelect();
    const route = this.$route;
    let q = JSON.parse(JSON.stringify(route.query));
    q = Object.assign(q, this.listParam);
    for (const key in q) {
      q[key] = String(q[key]);
    }
    const args = {
      mode: this.modeType,
      ...this.listParam,
      ...this.propParams,
    };
    this.load = true;
    mechanismApi.pageChangeApply(args).then((r: any) => {
      if (r.data.result === 0) {
        const rData = r.data.data.records;
        this.total = r.data.data.total;
        this.dataList = rData;
        if (callback) {
          callback();
        }
        this.$nextTick(() => {
          let $table = this.$refs.table as HTMLFormElement;
          if ($table) {
            $table.doLayout();
          }
          this.load = false;
        })
      }
    });
  }

  indexMethod(index: any) {
    return (this.listParam.current - 1) * this.listParam.size + index + 1;
  }

  memberSelect(selection: any, row: any) {
    this.allSelected = selection;
  }

  changeTabCol(e: any) {
    this.tabCol = e;
    this.$nextTick(() => {
      let $table = this.$refs.table as HTMLFormElement;
      if ($table) {
        $table.doLayout();
      }
    })
  }

  toDetail(type: string) {
    const dataArr = this.allSelected as any;
    if (dataArr.length == 0) {
      this.$message.error("请先勾选");
      return;
    }
    if (dataArr.length > 1) {
      this.$message.error("只能勾选一条");
      return;
    }

    if(['AUDIT', 'VIEW'].includes(type)){
      this.openDialog(dataArr[0], type);
      return;
    }
  }

  openDialog(info: any, mode: string) {
    this.changeApplyDialog.info = info;
    this.changeApplyDialog.mode = mode;
    this.changeApplyDialog.visible = true;
  }

  pageSizeChange(val: number) {
    this.listParam.size = val;
    this.refresh();
  }

  pageCurrentChange(val: number) {
    this.listParam.current = val;
    this.loadData(null);
  }
}
